import React, { Component, Fragment } from "react"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import Card from "@material-ui/core/Card"
import CardContent from "@material-ui/core/CardContent"
import CardMedia from "@material-ui/core/CardMedia"
import Button from "@material-ui/core/Button"
import Typography from "@material-ui/core/Typography"
import Image from "../../assets/images/login_bg.jpg"
import Divider from "@material-ui/core/Divider"
import IconButton from "@material-ui/core/IconButton"
import MoreVertIcon from "@material-ui/icons/MoreVert"
import PlaceIcon from "@material-ui/icons/Place"
import Grid from "@material-ui/core/Grid"
import Rating from "../../components/Rating"
import classNames from "classnames"
import Popover from "@material-ui/core/Popover"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemText from "@material-ui/core/ListItemText"
import Modal from "@material-ui/core/Modal"
import EliteImage from "../../assets/images/elite1.png"
import { isEmpty, capitalize, flatten } from "lodash"
import Menu from "@material-ui/core/Menu"
import MenuItem from "@material-ui/core/MenuItem"
import { hiddenLoginModal } from "../../actions/authentication"
import Tooltip from "@material-ui/core/Tooltip"
import green from "@material-ui/core/colors/green"
import LocalHospitalIcon from "@material-ui/icons/LocalHospital"

class CrewCard extends Component {
  constructor(props) {
    super(props)

    this.state = {
      searchTerm: "",
      checked: false,
      equipmentAnchor: null,
      vehicleAnchor: null,
      positionsAnchor: null,
      videoModalOpen: false,
      menuAnchorEl: null,
    }
  }

  handleBook = () => {
    hiddenLoginModal()
      .then(res => {
        this.props.onOpenBookingDialog(this.props.crew)
      })
      .catch(err => console.log({ err }))
  }

  handleRating = num => {
    hiddenLoginModal()
      .then(res => {
        this.props.ratingChanged(num)
      })
      .catch(err => console.log({ err }))
  }

  handleOpenMenu = e => {
    this.setState({ menuAnchorEl: e.currentTarget })
  }
  handleCloseMenu = () => {
    this.setState({ menuAnchorEl: null })
  }
  handleMenuItemClick = (action, note) => {
    this.handleCloseMenu()
    this.props.onRemoveFromCompany(this.props.crew)
  }
  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    })
  }

  handleChecked = event => {
    this.setState({ checked: event.target.checked })
  }
  handlePopoverOpen = (name, event) => {
    this.setState({ [`${name}Anchor`]: event.target })
  }

  handlePopoverClose = name => {
    this.setState({ [`${name}Anchor`]: null })
  }
  generate(element) {
    return [0, 1, 2].map(value =>
      React.cloneElement(element, {
        key: value,
      })
    )
  }
  beforeOpenModal = e => {
    const crew = this.props.crew
    let url = `/${crew.id}`
    if (e.target.id === "card-media") {
      if (this.props.currentUser.id) {
        this.props.onOpenProfile()
      } else {
        const { locations, roles } = crew
        // first_name && first_name.length > 0 && (url += `/${first_name}`)
        // last_name && last_name.length > 0 && (url += `_${last_name}`)
        this.props.isPositionSearch && this.props.isPositionSearch.name
          ? (url += `/${this.props.isPositionSearch.name.replace(/\W/g, "_")}`)
          : roles &&
          roles.length > 0 &&
          (url += `/${roles[
            Math.floor(Math.random() * roles.length)
          ].name.replace(/\W/g, "_")}`)
        locations &&
          locations.length > 0 &&
          (url += `/${locations[
            Math.floor(Math.random() * locations.length)
          ].city.replace(/\W/g, "_")}`)
        window.location.href = window.location.origin + url.toLowerCase()
      }
    }
  }

  hasNotClaimed = () => {
    return (
      flatten([
        this.props.crew.roles,
        this.props.crew.locations,
        this.props.crew.equipment,
        this.props.crew.vehicles,
      ]).find(c => c.creator_id === this.props.crew.id) === undefined
    )
  }
  render() {
    const {
      equipmentAnchor,
      vehicleAnchor,
      positionsAnchor,
      menuAnchorEl,
    } = this.state
    const { isPositionSearch } = this.props
    const currentPosition = this.props.crew.roles.find(
      r => r.name === isPositionSearch.name
    )
    const equipmentOpen = !!equipmentAnchor
    const vehicleOpen = !!vehicleAnchor
    const positionsOpen = !!positionsAnchor
    let companyRating = undefined
    if (this.props.accessLevel === 1) {
      companyRating = this.props.crew.ratings
        .sort((a, b) => b.score - a.score)
        .find(r => r.company_id === this.props.activeCompany)
    }
    const myRating = this.props.crew.ratings
      .sort((a, b) => b.score - a.score)
      .find(
        r => r.creator_id === this.props.currentUser.id && r.company_id === 0
      )
    let selectedRating = 0
    if (companyRating) {
      selectedRating = companyRating.score
    } else if (myRating && this.props.activeCompany === null) {
      selectedRating = myRating.score
    }
    const canDelete =
      this.props.activeCompany === 3 ||
      (this.props.crew.companies.length === 1 &&
        this.props.crew.companies[0].id === this.props.activeCompany &&
        this.hasNotClaimed())

    // console.log("can delete", this.props.activeCompany)
    return (
      <Card
        className={this.props.classes.card}
      // style={{
      // border: this.props.crew.membershipValid ? "2px solid #0CADFF" : null,
      // }}
      >
        <CardMedia
          id="card-media"
          onClick={this.beforeOpenModal}
          className={classNames(
            this.props.classes.trigger,
            this.props.classes.media,
            {
              [this.props.classes.imageOverlay]:
                selectedRating === 6 || selectedRating === -1,
              [this.props.classes.imageOverlayPreferred]: selectedRating === 6,
              [this.props.classes.imageOverlayDoNotUse]: selectedRating === -1,
            }
          )}
          image={
            !isEmpty(this.props.crew.profile_image)
              ? `https://res.cloudinary.com/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME
              }/image/upload/c_thumb,g_face:auto,z_0.7,h_170,w_300,fl_lossy,f_auto/v${this.props.crew.profile_image.version
              }/${this.props.crew.profile_image.public_id}.${this.props.crew.profile_image.format
              }`
              : Image
          }
        >
          {/*<Checkbox
className={this.props.classes.checkBox}
checked={this.state.checked}
onChange={this.handleChecked}
value="checkedA"
classes={{
root: this.props.classes.checkBoxRoot,
checked: this.props.classes.checkBoxChecked,
}}
/>*/}
          {canDelete && (
            <IconButton
              className={this.props.classes.moreButton}
              onClick={this.handleOpenMenu}
              aria-label="Options"
            >
              <MoreVertIcon />
            </IconButton>
          )}
          <Menu
            anchorEl={menuAnchorEl}
            open={Boolean(menuAnchorEl)}
            onClose={this.handleCloseMenu}
            getContentAnchorEl={null}
            anchorOrigin={{
              vertical: "center",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <MenuItem onClick={this.handleMenuItemClick}>
              Delete Profile
            </MenuItem>
          </Menu>
          {this.props.crew.badges.length > 0 && (
            <div className={this.props.classes.badgeWrapper}>
              <img
                src={EliteImage}
                className={this.props.classes.badgeImage}
                alt="Elite"
              />
            </div>
          )}
        </CardMedia>
        {/* {this.props.crew &&
window.location.host.search("staging") >= 0 && (
<div>{this.props.crew.master_rating}</div>
)} */}
        <CardContent className={this.props.classes.cardContent}>
          <Grid container alignItems="center">
            <Grid item xs={8}>
              <Typography
                onClick={this.beforeOpenModal}
                gutterBottom
                variant="h5"
                component="h2"
                className={classNames(
                  this.props.classes.cardHeadline,
                  this.props.classes.trigger
                )}
              >
                {this.props.crew.first_name} {this.props.crew.last_name}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Grid container justify="flex-end">
                <div className={this.props.classes.icons} style={{ width: "60px" }}>
                  <i
                    onClick={() =>
                      this.props.crew.video
                        ? this.setState({ videoModalOpen: true })
                        : false
                    }
                    className={classNames(
                      "icon-reel",
                      this.props.classes.icon,
                      this.props.classes.reelIcon,
                      this.props.classes.trigger,
                      {
                        [this.props.classes.iconDisabled]: !this.props.crew
                          .video,
                      }
                    )}
                  />
                  <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.videoModalOpen}
                    onClose={() => this.setState({ videoModalOpen: false })}
                  >
                    <div className={this.props.classes.modal}>
                      <div
                        style={{
                          padding: "56.25% 0 0 0",
                          position: "relative",
                        }}
                      >
                        <iframe
                          title="vimeo-player"
                          src={`https://player.vimeo.com/video/${this.props.crew.video
                            }?title=0&byline=0&portrait=0`}
                          style={{
                            position: "absolute",
                            top: "0",
                            left: "0",
                            width: "100%",
                            height: "100%",
                          }}
                          frameBorder="0"
                        />
                      </div>
                      <script src="https://player.vimeo.com/api/player.js" />
                    </div>
                  </Modal>
                  <i
                    className={classNames(
                      "icon-box",
                      this.props.classes.icon,
                      this.props.classes.boxIcon,
                      this.props.classes.trigger,
                      {
                        [this.props.classes.iconDisabled]:
                          this.props.crew.equipment.length === 0,
                      }
                    )}
                    onMouseOver={event =>
                      this.props.crew.equipment.length > 0
                        ? this.handlePopoverOpen("equipment", event)
                        : false
                    }
                    onMouseOut={() => this.handlePopoverClose("equipment")}
                  />



                  <Popover
                    className={this.props.classes.popover}
                    classes={{
                      paper: this.props.classes.popoverPaper,
                    }}
                    open={equipmentOpen}
                    anchorEl={equipmentAnchor}
                    onClose={() => this.handlePopoverClose("equipment")}
                    anchorOrigin={{
                      vertical: "center",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "center",
                      horizontal: "left",
                    }}
                    disableRestoreFocus
                  >
                    <Typography
                      variant="h6"
                      className={this.props.classes.popoverTitle}
                    >
                      Equipment
                    </Typography>
                    <List>
                      {this.props.crew.equipment.map(equipment => (
                        <ListItem
                          key={equipment.id}
                          className={this.props.classes.listItem}
                        >
                          <ListItemText disableTypography>
                            <Typography className={this.props.classes.listText}>
                              {equipment.name}
                            </Typography>
                          </ListItemText>
                        </ListItem>
                      ))}
                    </List>
                  </Popover>
                  <i
                    className={classNames(
                      "icon-vehicle",
                      this.props.classes.icon,
                      this.props.classes.vehicleIcon,
                      this.props.classes.trigger,
                      {
                        [this.props.classes.iconDisabled]:
                          this.props.crew.vehicles.length === 0,
                      }
                    )}
                    onMouseOver={event =>
                      this.props.crew.vehicles.length > 0
                        ? this.handlePopoverOpen("vehicle", event)
                        : false
                    }
                    onMouseOut={() => this.handlePopoverClose("vehicle")}
                  />
                  <Popover
                    className={this.props.classes.popover}
                    classes={{
                      paper: this.props.classes.popoverPaper,
                    }}
                    open={vehicleOpen}
                    anchorEl={vehicleAnchor}
                    onClose={() => this.handlePopoverClose("vehicle")}
                    anchorOrigin={{
                      vertical: "center",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "center",
                      horizontal: "left",
                    }}
                    disableRestoreFocus
                  >
                    <Typography
                      variant="h6"
                      className={this.props.classes.popoverTitle}
                    >
                      Vehicles
                    </Typography>
                    <List>
                      {this.props.crew.vehicles.map(vehicle => (
                        <ListItem
                          key={vehicle.id}
                          className={this.props.classes.listItem}
                        >
                          <ListItemText disableTypography>
                            <Typography className={this.props.classes.listText}>
                              {capitalize(vehicle.make)}{" "}
                              {capitalize(vehicle.model)} {vehicle.year}
                            </Typography>
                          </ListItemText>
                        </ListItem>
                      ))}
                    </List>
                  </Popover>
                </div>
                {this.props.crew.vaccinated === 1 && (
                  <div style={{ padding: "5px" }}>
                    <Tooltip
                      placement="top"
                      title={"The crew member is vaccinated"}
                    >
                      <LocalHospitalIcon style={{ color: green[500] }} />
                    </Tooltip>
                  </div>
                )}
              </Grid>
            </Grid>
          </Grid>
          {this.props.crew.locations.length > 0 &&
            this.props.crew.locations[0].hasOwnProperty("city") && (
              <div className={this.props.classes.primaryPlace}>
                <PlaceIcon className={this.props.classes.placeIcon} />
                <Typography
                  variant="caption"
                  className={this.props.classes.placeName}
                  color="inherit"
                >
                  {this.props.crew.locations[0].label}
                </Typography>
              </div>
            )}
          {!this.props.hideRating && (
            <div className={this.props.classes.rating}>
              <Rating
                avgRating={this.props.crew.avg_rating}
                userId={this.props.crew.id}
                totalRatings={
                  this.props.crew.ratings.filter(r => r.score > -1).length
                }
                selectedRating={selectedRating}
                ratingChanged={this.handleRating}
              />
            </div>
          )}
          <div className={this.props.classes.bottomArea}>
            {/*this.props.accessLevel === 1 &&
this.props.currentUser.id !== this.props.crew.id && (
Button
className={this.props.classes.messageButton}
variant="contained"
onClick={() =>
this.props.onOpenMessageDrawer(this.props.crew)
}
size="small"
color="primary"
>
Message
</Button>
)*/}
            {!this.props.bottomArea ? (
              <Button
                variant="contained"
                onClick={() => this.handleBook()}
                size="small"
                color="primary"
              >
                Book
              </Button>
            ) : (
              <Fragment>{this.props.bottomArea()}</Fragment>
            )}
            <div className={this.props.classes.positionsArea}>
              {/*}
{!isPositionSearch &&
<Badge badgeContent={4} classes={{ badge: this.props.classes.badge }}>
<Typography gutterBottom variant="subtitle1" className={classNames(this.props.classes.positions,this.props.classes.trigger)}
onMouseOver={(event) => this.handlePopoverOpen('positions',event)}
onMouseOut={() => this.handlePopoverClose('positions')}>
Multiple Positions
</Typography>
</Badge>
}
*/}
              {isPositionSearch &&
                currentPosition && (
                  <Fragment>
                    <Typography
                      gutterBottom
                      variant="subtitle1"
                      className={this.props.classes.positions}
                    >
                      {isPositionSearch.name}
                    </Typography>
                    {currentPosition.rate ? (
                      <Typography
                        gutterBottom
                        variant="h5"
                        className={this.props.classes.positionRate}
                      >
                        {currentPosition.rate
                          ? `$${currentPosition.rate}`
                          : "-"}
                      </Typography>
                    ) : null}
                  </Fragment>
                )}
              <Popover
                className={this.props.classes.popover}
                classes={{
                  paper: this.props.classes.popoverPaper,
                }}
                open={positionsOpen}
                anchorEl={positionsAnchor}
                onClose={() => this.handlePopoverClose("positions")}
                anchorOrigin={{
                  vertical: "center",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "center",
                  horizontal: "left",
                }}
                disableRestoreFocus
              >
                <List>
                  {this.generate(
                    <ListItem>
                      <ListItemText primary="Position Name" />
                    </ListItem>
                  )}
                </List>
              </Popover>
            </div>
          </div>
        </CardContent>
        <Divider />
      </Card>
    )
  }
}

export default withStyles(styles, { withTheme: true })(CrewCard)

